
import Results from './components/Results';
import './components/StoreCash.css'
import {FirebaseProvider} from './context/firebaseContext/FirebaseConext'
const hasprdMessaging = document.getElementById('prdMessaging')
hasprdMessaging && console.log('hasprdMessaging',hasprdMessaging,'text',hasprdMessaging.innerText,'html',hasprdMessaging.innerHTML) 

function App() {
  return (
    <FirebaseProvider>

    <div className={`ggds storecashPdp_slider marg-top-10 text-left ${hasprdMessaging ? 'container unbuyable' : ''} `} >
      <Results/>
    </div> 
    </FirebaseProvider>
  );
}

export default App;
